// extracted by mini-css-extract-plugin
export default {"logo":"Header_logo__0CcQ-","menuToggle":"Header_menuToggle__wjf5h"};